import { render, staticRenderFns } from "./paginationBlog.vue?vue&type=template&id=647fc520&"
import script from "./paginationBlog.vue?vue&type=script&lang=js&"
export * from "./paginationBlog.vue?vue&type=script&lang=js&"
import style0 from "./paginationBlog.vue?vue&type=style&index=0&id=647fc520&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('647fc520')) {
      api.createRecord('647fc520', component.options)
    } else {
      api.reload('647fc520', component.options)
    }
    module.hot.accept("./paginationBlog.vue?vue&type=template&id=647fc520&", function () {
      api.rerender('647fc520', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/partial/blog/paginationBlog.vue"
export default component.exports